import ReactApexChart from "react-apexcharts";

const chartOptions = {
    chart: {
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: false,
        },
    },
    tooltip: {
        theme: "dark",
    },
    dataLabels: {
        enabled: false,
    },
    xaxis: {
        categories: ["17-25", "26-35", "36-45", "46-55", "56+"],
        labels: {
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        type: "numeric",
        labels: {
            formatter: (label, opts) => {
                const total = opts.w.globals.series[opts.seriesIndex].reduce((sum, x) => {return sum + x;}, 0);
                const val = total > 0 ? parseInt(100 * opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] / total) : 0;
                return label + ' (' + val + '%)';
            },
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
    },
    legend: {
        show: false,
    },
    grid: {
        show: false,
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
        }
    },
};

const chartData = [
    {
      name: "Households by age range",
      data: [50, 64, 48, 66, 168]
    }
];

function HouseHoldsAgeRange() {
    const newOptions = {
        ...chartOptions,
        colors: ["#A7D5BA"],
    };

    return (
        <>
            <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* header */}
                <div className="flex">
                    <div className="flex-1">
                        <p className="text-gray-800 font-bold dark:text-white">Households by age range</p>
                    </div>
                    <select className="flex-none bg-[transparent] text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
                        <option>Monthly</option>
                    </select>
                </div>

                {/* chart */}
                <div className="block h-[300px]">
                    <div className="h-full w-full">
                        <ReactApexChart
                            options={newOptions}
                            series={chartData}
                            type="bar"
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default HouseHoldsAgeRange;
